import clsx from 'clsx'
import spaces from './spacing.module.css'
import { AssetChildComponentSpacing } from './types'

export const getSpacingClassName = ({ margin, marginBottom, marginTop }: AssetChildComponentSpacing): string =>
  clsx(margin && spaces[`margin${margin}`], marginTop && spaces[`margin${marginTop}Top`], marginBottom && spaces[`margin${marginBottom}Bottom`])
